import { SaleItem } from 'app/core/interfaces/finances';
import { EntityWithChildren } from 'app/core/interfaces/ui';

export const isIdemSale = (
    saleOne: EntityWithChildren,
    saleTwo: EntityWithChildren
): boolean => {
    if (!saleOne.children || !saleTwo.children) {
        console.log('One of the sales does not have children');
        return false;
    }

    return saleOne.children.some(
        (child: { saleId: number }) =>
            child.saleId === saleTwo.children[0].saleId
    );
};

export const updateChild = (
    saleOne: EntityWithChildren,
    saleTwo: EntityWithChildren
): SaleItem[] => {
    if (!saleOne.children || !saleTwo.children) {
        console.log('One of the sales does not have children');
        return [];
    }

    if (saleTwo.children.length === 0) {
        console.log('The updated sale does not have any children');
        return saleOne.children;
    }

    return saleOne.children.map((_child: SaleItem) => {
        const updatedChild = saleTwo.children.find(
            (child: { saleId: number }) => child.saleId === _child.saleId
        );
        return updatedChild ? updatedChild : _child;
    });
};
